import React, { useState, useContext, useEffect } from 'react'
import {
  Form,
  Switch,

  Divider,
} from 'antd'

import { CreateMemberLyfeContext } from '../../../../../../..'
// import TooltipInfo from '../../../../../../../../CreateEventV2/TooltipInfo'

import SessionForm from './SessionForm'
import './index.styl'

const { Item, List } = Form

const Sessions = ({ currentPageDetails }) => {
  const { form } = useContext(CreateMemberLyfeContext)

  const [sessionsSwitch, setSessionsSwitch] = useState(false)
  const [sessions, setSessions] = useState(form.getFieldValue('sessions') || [])

  // const mobile = window.innerWidth <= 730
  // const tooltipTitle = `Charity Raffles are limited to $30,000 in total ticket sales and $100 max price per ticket

  // Ticket Lyfe charges for Charity Raffle Tickets are $1 for Raffles priced up to $50 and $2 for higher priced Raffle Tickets

  // Do not pick Charity Raffles if you are doing a regular event with Random Draw Prizes--Because you can do a Random Draw on ANY Ticket Lyfe Event, the Charity Raffle limits above will not apply, and Ticket Lyfe treat your event as an ordinary Ticketed Event`

  // const additionalTooltip = (
  //  <TooltipInfo
  //    className='tooltipTitle'
  //    text={mobile ? '' : 'Additional info'}
  //    info={tooltipTitle}
  //  />
  // )

  useEffect(() => {
    if (!!currentPageDetails?.sessions?.length) {
      setSessionsSwitch(true)
      setSessions(currentPageDetails.sessions)
      form.setFieldsValue({
        sessions: currentPageDetails.sessions,
      })
    }
  }, [currentPageDetails, form])

  useEffect(() => {
    if (!sessions.length) {
      setSessionsSwitch(false)
      form.setFieldsValue({
        sessionsSwitch: false,
      })
    }
  }, [sessions, form])

  const handleSwitchChange = checked => {
    setSessionsSwitch(checked)
    if (checked && !sessions.length) {
      const newSession = [{}]
      setSessions(newSession)
      form.setFieldsValue({
        sessions: newSession,
      })
    }
  }

  const getSessionsData = idx => {
    return sessions[idx]
  }

  return (
    <div className='sessionAndPassesWrapper'>
      <div className={sessionsSwitch ? 'betweenWraper active' : 'betweenWraper'}>
        <div className='radioWrapper'>
          <Item style={{ marginBottom: 0 }} name='sessionsSwitch' valuePropName='checked' className='item'>
            <Switch onChange={handleSwitchChange} />
          </Item>
          <div className='text'>Sessions</div>
        </div>
        {/* <div className='tooltipWrapper'>{additionalTooltip}</div> */}
      </div>
      {sessionsSwitch && (
        <List name='sessions'>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, fieldKey, ...restField }) => (
                <SessionForm
                  form={form}
                  currentPageDetails={currentPageDetails}
                  categoryData={getSessionsData(fieldKey)}
                  key={key}
                  name={name}
                  fieldKey={fieldKey}
                  onRemove={index => {
                    remove(index)
                    const updatedSessions = form.getFieldValue('sessions')
                    setSessions(updatedSessions)
                    if (updatedSessions.length === 0) {
                      form.setFieldsValue({
                        sessionsSwitch: false,
                      })
                    }
                  }}
                  {...restField}
                />
              ))}
              <div
                id='addCategory'
                className='addCategoryBtn'
                onClick={() => {
                  add()
                  const updatedSessions = form.getFieldValue('sessions')
                  setSessions(updatedSessions)
                }}
              >
                Add Another Session
              </div>
            </>
          )}
        </List>
      )}
      <Divider />
    </div>
  )
}

export default Sessions
